import { useState } from "react";
import { toast } from "sonner";
import { Warning } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";
import { api, errMsg } from "@/lib/api";

const PHRASE = "VERİLERİ SİL";

export default function DangerZone() {
  const [open, setOpen] = useState(false);
  const [confirm, setConfirm] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const run = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/admin/reset-data", { confirm, password });
      const n = Object.values(data.removed).reduce((a, b) => a + b, 0);
      toast.success(`Temizlik tamamlandı: ${n} kayıt silindi.`);
      setTimeout(() => window.location.assign("/"), 800);
    } catch (err) {
      toast.error(errMsg(err));
    }
    setBusy(false);
  };

  return (
    <div className="border border-red-200 bg-red-50/40 p-5" data-testid="danger-zone">
      <h3 className="flex items-center gap-2 font-display text-lg font-bold text-red-700"><Warning size={18} weight="fill" /> Tehlikeli Bölge</h3>
      <p className="mt-1 text-sm text-red-900/80">
        Tüm cari, ürün, fatura, sipariş, tahsilat, sevkiyat, çek/senet, dosya ve işlem geçmişi kayıtlarını; sizin dışınızdaki tüm kullanıcıları ve deneme şirketlerini kalıcı olarak siler.
        Firma bilgileri ve işveren hesabınız korunur. <b>Geri alınamaz.</b>
      </p>
      {!open ? (
        <Button type="button" variant="destructive" className="mt-4 rounded-[4px]" onClick={() => setOpen(true)} data-testid="reset-data-open-button">Tüm verileri temizle…</Button>
      ) : (
        <form onSubmit={run} className="mt-4 max-w-sm space-y-3">
          <Field label={`Onaylamak için "${PHRASE}" yazın`}>
            <Input value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-data-confirm-input" className="rounded-[4px]" />
          </Field>
          <Field label="Şifreniz">
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-data-password-input" className="rounded-[4px]" />
          </Field>
          <div className="flex gap-2">
            <Button type="submit" variant="destructive" disabled={busy || confirm !== PHRASE || !password} className="rounded-[4px]" data-testid="reset-data-submit-button">
              {busy ? "Siliniyor…" : "Evet, kalıcı olarak sil"}
            </Button>
            <Button type="button" variant="outline" onClick={() => setOpen(false)} className="rounded-[4px]" data-testid="reset-data-cancel-button">Vazgeç</Button>
          </div>
        </form>
      )}
    </div>
  );
}
